import React, { useEffect, useRef, useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { navItems } from "./data";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [concealed, setConcealed] = useState(false);
  const [elevated, setElevated] = useState(false);
  const lastScrollYRef = useRef(0);
  const frameRef = useRef(null);

  useEffect(() => {
    lastScrollYRef.current = window.scrollY;

    const updateNavigation = () => {
      const currentScrollY = window.scrollY;
      const distance = currentScrollY - lastScrollYRef.current;
      const atTop = currentScrollY < 32;

      setElevated(!atTop);

      if (atTop || open) {
        setConcealed(false);
      } else if (distance > 8 && currentScrollY > 140) {
        setConcealed(true);
      } else if (distance < 0) {
        setConcealed(false);
      }

      lastScrollYRef.current = currentScrollY;
      frameRef.current = null;
    };

    const handleScroll = () => {
      if (frameRef.current === null) {
        frameRef.current = window.requestAnimationFrame(updateNavigation);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frameRef.current !== null) window.cancelAnimationFrame(frameRef.current);
    };
  }, [open]);

  const moveTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
    setConcealed(false);
  };

  const toggleMenu = () => {
    setConcealed(false);
    setOpen((value) => !value);
  };

  const navClassName = [
    "ops-nav",
    concealed ? "nav-concealed" : "nav-revealed",
    elevated ? "nav-elevated" : ""
  ].filter(Boolean).join(" ");

  return (
    <header className={navClassName}>
      <button className="brand-lockup" type="button" onClick={() => moveTo("home")} aria-label="Return to command center">
        <span className="brand-sigil">E</span>
        <span>
          <strong>E-OPS</strong>
          <small>Cyber Operations System</small>
        </span>
      </button>
      <nav className={open ? "nav-links open" : "nav-links"} aria-label="Primary navigation">
        {navItems.map(([label, id]) => (
          <button type="button" key={id} onClick={() => moveTo(id)}>
            {label}
          </button>
        ))}
      </nav>
      <button className="nav-toggle" type="button" onClick={toggleMenu} aria-label="Toggle navigation" aria-expanded={open}>
        {open ? <FiX /> : <FiMenu />}
      </button>
    </header>
  );
}

export default Navbar;
